import React, { useRef } from 'react';
import { Icon } from '../../icon/index.js';
import { FCThemeConsumer } from '../../../theming/FCTheme.js';
import { RadioInput, IconStyled, Label } from './style.js';
var Radio = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var children = _a.children,
      _b = _a.checked,
      checked = _b === void 0 ? false : _b,
      _c = _a.inWarning,
      inWarning = _c === void 0 ? false : _c,
      _d = _a.inError,
      inError = _d === void 0 ? false : _d,
      value = _a.value,
      _e = _a.onKeyDown,
      _onKeyDown = _e === void 0 ? function () {
    return undefined;
  } : _e,
      _f = _a.onChange,
      _onChange = _f === void 0 ? function () {
    return undefined;
  } : _f,
      _onClick = _a.onClick,
      id = _a.id,
      _g = _a.radioTabIndex,
      radioTabIndex = _g === void 0 ? 0 : _g;

  var RadioRef = useRef(null);
  return /*#__PURE__*/React.createElement(FCThemeConsumer, null, function (themeContext) {
    return /*#__PURE__*/React.createElement("label", {
      onClick: function onClick() {
        return _onClick && _onClick();
      }
    }, /*#__PURE__*/React.createElement(RadioInput, {
      id: id,
      value: value,
      type: "radio",
      ref: RadioRef,
      tabIndex: -1,
      checked: checked,
      onChange: function onChange(e) {
        return _onChange(e);
      }
    }), /*#__PURE__*/React.createElement(IconStyled, {
      tabIndex: radioTabIndex,
      ref: ref,
      onKeyDown: function onKeyDown(e) {
        return _onKeyDown && _onKeyDown(e);
      },
      role: "radio",
      inError: inError,
      inWarning: inWarning,
      theme: themeContext.theme,
      "aria-checked": checked ? true : false
    }, /*#__PURE__*/React.createElement(Icon, {
      "aria-labelledby": "labelfor-" + id,
      icon: checked ? 'radio-checked' : 'radio'
    })), /*#__PURE__*/React.createElement(Label, {
      id: "labelfor-" + id,
      theme: themeContext.theme,
      inError: inError,
      inWarning: inWarning
    }, children));
  });
});
Radio.displayName = 'Radio';
export default Radio;
export { Radio };